import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Footer from '../home/components/Footer';

interface VehicleData {
  id: number;
  name: string;
  price: number;
  mileage: string;
  location: string;
  badge: string;
  images: string[];
  year?: string;
  make?: string;
  model?: string;
  trim?: string;
  vin?: string;
  stockNumber?: string;
  exteriorColor?: string;
  interiorColor?: string;
  transmission?: string;
  drivetrain?: string;
  fuelType?: string;
  engine?: string;
  mpgCity?: string;
  mpgHighway?: string;
  features?: string[];
  description?: string;
}

const mockVehicles = [
  {
    id: 1,
    name: '2018 Honda Accord Sport',
    price: 18995,
    image: 'https://public.readdy.ai/ai/img_res/4d4bde95cc4f87e05d9b3ec13ad7150b.jpg',
    year: 2018,
    mileage: '132,450',
    location: 'Fayetteville, GA',
    badge: 'Best Value',
    specs: {
      engine: '1.5L Turbo I4',
      transmission: 'CVT Automatic',
      drivetrain: 'FWD',
      fuelEconomy: '30/38 MPG',
      exteriorColor: 'Modern Steel Metallic',
      interiorColor: 'Black Cloth',
      doors: 4,
      seats: 5,
    },
    features: [
      'Apple CarPlay & Android Auto',
      'Dual-Zone Climate Control',
      'Honda Sensing Safety Suite',
      'LED Headlights',
      'Sport Alloy Wheels',
      'Power Moonroof',
      'Bluetooth Connectivity',
      'Backup Camera',
    ],
  },
  {
    id: 2,
    name: '2020 Toyota Camry SE',
    price: 22495,
    image: 'https://readdy.ai/api/search-image?query=stunning%20white%202020%20Toyota%20Camry%20SE%20sedan%20in%20professional%20dealership%20photography%20with%20clean%20white%20studio%20background%20showcasing%20aggressive%20sporty%20design%20bold%20grille%20and%20sleek%20profile%20high%20quality%20automotive%20commercial%20shot&width=800&height=600&seq=compare2&orientation=landscape',
    year: 2020,
    mileage: '18,200',
    location: 'Fayetteville, GA',
    badge: 'Just Arrived',
    specs: {
      engine: '2.5L I4',
      transmission: '8-Speed Automatic',
      drivetrain: 'FWD',
      fuelEconomy: '28/39 MPG',
      exteriorColor: 'Super White',
      interiorColor: 'Black SofTex',
      doors: 4,
      seats: 5,
    },
    features: [
      'Toyota Safety Sense 2.0',
      'Apple CarPlay & Android Auto',
      'Wireless Charging',
      'Sport-Tuned Suspension',
      '19-inch Black Alloy Wheels',
      'LED Headlights & Taillights',
      'Dual-Zone Climate Control',
      'Smart Key System',
    ],
  },
  {
    id: 3,
    name: '2019 Mazda CX-5 Grand Touring',
    price: 24995,
    image: 'https://readdy.ai/api/search-image?query=elegant%20deep%20blue%202019%20Mazda%20CX5%20Grand%20Touring%20SUV%20in%20professional%20dealership%20photography%20with%20clean%20white%20studio%20background%20showcasing%20premium%20design%20sophisticated%20styling%20and%20luxury%20details%20high%20quality%20automotive%20commercial%20shot&width=800&height=600&seq=compare3&orientation=landscape',
    year: 2019,
    mileage: '45,800',
    location: 'Fayetteville, GA',
    badge: 'Popular',
    specs: {
      engine: '2.5L I4',
      transmission: '6-Speed Automatic',
      drivetrain: 'AWD',
      fuelEconomy: '25/31 MPG',
      exteriorColor: 'Deep Crystal Blue',
      interiorColor: 'Parchment Leather',
      doors: 4,
      seats: 5,
    },
    features: [
      'Leather Seats',
      'Bose Premium Audio',
      'Power Liftgate',
      'Heated Front Seats',
      'Navigation System',
      'Blind Spot Monitoring',
      'Adaptive Cruise Control',
      'Head-Up Display',
    ],
  },
  {
    id: 4,
    name: '2021 Hyundai Tucson Limited',
    price: 26995,
    image: 'https://readdy.ai/api/search-image?query=sophisticated%20gray%202021%20Hyundai%20Tucson%20Limited%20SUV%20in%20professional%20dealership%20photography%20with%20clean%20white%20studio%20background%20showcasing%20modern%20premium%20design%20bold%20styling%20and%20luxury%20features%20high%20quality%20automotive%20commercial%20shot&width=800&height=600&seq=compare4&orientation=landscape',
    year: 2021,
    mileage: '12,500',
    location: 'Fayetteville, GA',
    badge: 'Low Miles',
    specs: {
      engine: '2.4L I4',
      transmission: '8-Speed Automatic',
      drivetrain: 'AWD',
      fuelEconomy: '22/28 MPG',
      exteriorColor: 'Magnetic Gray',
      interiorColor: 'Black Leather',
      doors: 4,
      seats: 5,
    },
    features: [
      'Panoramic Sunroof',
      'Leather Seats',
      'Infinity Premium Audio',
      'Wireless Charging',
      'Smart Cruise Control',
      'Lane Keep Assist',
      'Blind Spot Detection',
      '19-inch Alloy Wheels',
    ],
  },
  {
    id: 5,
    name: '2020 Nissan Rogue SL',
    price: 23495,
    image: 'https://readdy.ai/api/search-image?query=refined%20black%202020%20Nissan%20Rogue%20SL%20SUV%20in%20professional%20dealership%20photography%20with%20clean%20white%20studio%20background%20showcasing%20sleek%20premium%20design%20elegant%20styling%20and%20sophisticated%20details%20high%20quality%20automotive%20commercial%20shot&width=800&height=600&seq=compare5&orientation=landscape',
    year: 2020,
    mileage: '28,900',
    location: 'Fayetteville, GA',
    badge: 'Great Deal',
    specs: {
      engine: '2.5L I4',
      transmission: 'CVT Automatic',
      drivetrain: 'AWD',
      fuelEconomy: '26/33 MPG',
      exteriorColor: 'Magnetic Black Pearl',
      interiorColor: 'Charcoal Leather',
      doors: 4,
      seats: 5,
    },
    features: [
      'ProPILOT Assist',
      'Leather Seats',
      'Bose Premium Audio',
      'Panoramic Moonroof',
      'Around View Monitor',
      'Heated Steering Wheel',
      'Remote Start',
      'Power Liftgate',
    ],
  },
];

const defaultInventory: VehicleData[] = [
  {
    id: 1,
    name: '2016 Honda Pilot EX',
    price: 14995,
    mileage: '132,450',
    location: 'Fayetteville, GA',
    badge: 'Best Value',
    images: [
      'https://static.readdy.ai/image/e5292f43a8fca29a2b9f75d3d42cfb52/957de0cbdaf6ff81d22366c93b441658.jpeg',
    ],
    year: '2016',
    make: 'Honda',
    model: 'Pilot',
    trim: 'EX',
    vin: 'VIN123456789',
    stockNumber: 'STK00001',
    exteriorColor: 'White',
    interiorColor: 'Black',
    transmission: 'Automatic',
    drivetrain: 'AWD',
    fuelType: 'Gasoline',
    engine: '3.5L V6',
    mpgCity: '19',
    mpgHighway: '27',
    features: [
      'Backup Camera',
      'Bluetooth Connectivity',
      'Cruise Control',
      'Power Windows',
      'Power Locks',
      'Air Conditioning',
      'Alloy Wheels',
      'Keyless Entry',
      'Third Row Seating',
      'Leather Seats',
    ],
  },
  {
    id: 2,
    name: '2022 Toyota RAV4 XLE',
    price: 12995,
    mileage: '18,200',
    location: 'Fayetteville, GA',
    badge: 'Just Arrived',
    images: [
      'https://static.readdy.ai/image/e5292f43a8fca29a2b9f75d3d42cfb52/7ce8fa43afed15be988f5b4188f5d5ff.webp',
    ],
    year: '2022',
    make: 'Toyota',
    model: 'RAV4',
    trim: 'XLE',
    vin: 'VIN987654321',
    stockNumber: 'STK00002',
    exteriorColor: 'Silver',
    interiorColor: 'Gray',
    transmission: 'Automatic',
    drivetrain: 'AWD',
    fuelType: 'Gasoline',
    engine: '2.5L 4-Cylinder',
    mpgCity: '27',
    mpgHighway: '35',
    features: [
      'Backup Camera',
      'Bluetooth Connectivity',
      'Adaptive Cruise Control',
      'Lane Departure Warning',
      'Blind Spot Monitor',
      'Apple CarPlay',
      'Android Auto',
      'Heated Seats',
      'Sunroof',
      'Power Liftgate',
    ],
  },
  {
    id: 3,
    name: '2020 Ford F-150 XLT',
    price: 34995,
    mileage: '45,800',
    location: 'Fayetteville, GA',
    badge: 'Popular',
    images: [
      'https://readdy.ai/api/search-image?query=powerful%20blue%202020%20Ford%20F150%20XLT%20pickup%20truck%20displayed%20in%20professional%20automotive%20photography%20studio%20with%20clean%20white%20background%20and%20dramatic%20lighting%20emphasizing%20the%20truck%20rugged%20capability%20and%20bold%20design&width=800&height=600&seq=car3&orientation=landscape',
    ],
    year: '2020',
    make: 'Ford',
    model: 'F-150',
    trim: 'XLT',
    vin: 'VIN456789123',
    stockNumber: 'STK00003',
    exteriorColor: 'Blue',
    interiorColor: 'Black',
    transmission: 'Automatic',
    drivetrain: '4WD',
    fuelType: 'Gasoline',
    engine: '3.5L V6 EcoBoost',
    mpgCity: '20',
    mpgHighway: '26',
    features: [
      'Backup Camera',
      'Bluetooth Connectivity',
      'Cruise Control',
      'Tow Package',
      'Bed Liner',
      'Running Boards',
      'Power Seats',
      'Remote Start',
      'Trailer Brake Controller',
      'FX4 Off-Road Package',
    ],
  },
  {
    id: 4,
    name: '2023 Chevrolet Equinox LT',
    price: 27995,
    mileage: '12,500',
    location: 'Fayetteville, GA',
    badge: 'Low Miles',
    images: [
      'https://readdy.ai/api/search-image?query=elegant%20black%202023%20Chevrolet%20Equinox%20LT%20crossover%20SUV%20showcased%20in%20professional%20automotive%20studio%20with%20pristine%20white%20minimalist%20background%20and%20sophisticated%20lighting%20highlighting%20the%20vehicle%20sleek%20modern%20styling&width=800&height=600&seq=car4&orientation=landscape',
    ],
    year: '2023',
    make: 'Chevrolet',
    model: 'Equinox',
    trim: 'LT',
    vin: 'VIN789123456',
    stockNumber: 'STK00004',
    exteriorColor: 'Black',
    interiorColor: 'Beige',
    transmission: 'Automatic',
    drivetrain: 'FWD',
    fuelType: 'Gasoline',
    engine: '1.5L Turbo 4-Cylinder',
    mpgCity: '26',
    mpgHighway: '31',
    features: [
      'Backup Camera',
      'Bluetooth Connectivity',
      'Apple CarPlay',
      'Android Auto',
      'Keyless Entry',
      'Push Button Start',
      'Rear Parking Sensors',
      'WiFi Hotspot',
      'Teen Driver Mode',
      'OnStar',
    ],
  },
  {
    id: 5,
    name: '2021 Nissan Altima SR',
    price: 22995,
    mileage: '28,900',
    location: 'Fayetteville, GA',
    badge: 'Great Deal',
    images: [
      'https://readdy.ai/api/search-image?query=sporty%20red%202021%20Nissan%20Altima%20SR%20sedan%20presented%20in%20professional%20automotive%20photography%20studio%20with%20clean%20white%20background%20and%20dynamic%20lighting%20showcasing%20the%20vehicle%20athletic%20design%20and%20premium%20appearance&width=800&height=600&seq=car5&orientation=landscape',
    ],
    year: '2021',
    make: 'Nissan',
    model: 'Altima',
    trim: 'SR',
    vin: 'VIN321654987',
    stockNumber: 'STK00005',
    exteriorColor: 'Red',
    interiorColor: 'Black',
    transmission: 'CVT',
    drivetrain: 'FWD',
    fuelType: 'Gasoline',
    engine: '2.5L 4-Cylinder',
    mpgCity: '28',
    mpgHighway: '39',
    features: [
      'Backup Camera',
      'Bluetooth Connectivity',
      'Apple CarPlay',
      'Android Auto',
      'Sport Seats',
      'Sport Suspension',
      'Paddle Shifters',
      'Dual-Zone Climate',
      'Intelligent Cruise Control',
      'ProPILOT Assist',
    ],
  },
];

export default function ComparePage() {
  const navigate = useNavigate();
  const location = useLocation();

  // State definitions
  const [selectedVehicles, setSelectedVehicles] = useState<VehicleData[]>([]);
  const [availableVehicles, setAvailableVehicles] = useState<VehicleData[]>(defaultInventory);
  const [showAddModal, setShowAddModal] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');

  // Load vehicles from navigation state if any
  useEffect(() => {
    if (location.state && (location.state as any).vehicles) {
      setSelectedVehicles((location.state as any).vehicles);
    }
  }, [location.state]);

  const addVehicle = (vehicle: VehicleData) => {
    if (selectedVehicles.length < 4 && !selectedVehicles.find(v => v.id === vehicle.id)) {
      setSelectedVehicles([...selectedVehicles, vehicle]);
      setShowAddModal(false);
      setSearchQuery('');
    }
  };

  const removeVehicle = (vehicleId: number) => {
    setSelectedVehicles(selectedVehicles.filter(v => v.id !== vehicleId));
  };

  const filteredVehicles = availableVehicles.filter(vehicle =>
    vehicle.name.toLowerCase().includes(searchQuery.toLowerCase()) &&
    !selectedVehicles.find(v => v.id === vehicle.id)
  );

  const comparisonRows = [
    { label: 'Price', key: 'price', format: (v: VehicleData) => `$${v.price.toLocaleString()}` },
    { label: 'Year', key: 'year', format: (v: VehicleData) => v.year || 'N/A' },
    { label: 'Make', key: 'make', format: (v: VehicleData) => v.make || 'N/A' },
    { label: 'Model', key: 'model', format: (v: VehicleData) => v.model || 'N/A' },
    { label: 'Trim', key: 'trim', format: (v: VehicleData) => v.trim || 'N/A' },
    { label: 'Mileage', key: 'mileage', format: (v: VehicleData) => `${v.mileage} miles` },
    { label: 'Engine', key: 'engine', format: (v: VehicleData) => v.engine || 'N/A' },
    { label: 'Transmission', key: 'transmission', format: (v: VehicleData) => v.transmission || 'N/A' },
    { label: 'Drivetrain', key: 'drivetrain', format: (v: VehicleData) => v.drivetrain || 'N/A' },
    { label: 'Fuel Type', key: 'fuelType', format: (v: VehicleData) => v.fuelType || 'N/A' },
    { label: 'MPG City', key: 'mpgCity', format: (v: VehicleData) => v.mpgCity ? `${v.mpgCity} mpg` : 'N/A' },
    { label: 'MPG Highway', key: 'mpgHighway', format: (v: VehicleData) => v.mpgHighway ? `${v.mpgHighway} mpg` : 'N/A' },
    { label: 'Exterior Color', key: 'exteriorColor', format: (v: VehicleData) => v.exteriorColor || 'N/A' },
    { label: 'Interior Color', key: 'interiorColor', format: (v: VehicleData) => v.interiorColor || 'N/A' },
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white border-b border-gray-200 sticky top-0 z-40">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <button
            onClick={() => navigate('/')}
            className="flex items-center gap-2 text-gray-600 hover:text-gray-900 transition-colors cursor-pointer"
          >
            <i className="ri-arrow-left-line text-xl"></i>
            <span className="font-medium">Back to Inventory</span>
          </button>
          <h1 className="text-2xl font-bold text-gray-900">Compare Vehicles</h1>
          <div className="w-32"></div>
        </div>
      </header>

      {/* Main Content */}
      <section className="py-12">
        <div className="max-w-7xl mx-auto px-6">
          {selectedVehicles.length === 0 ? (
            <div className="text-center py-20">
              <div className="w-24 h-24 flex items-center justify-center bg-gray-100 rounded-full mx-auto mb-6">
                <i className="ri-car-line text-5xl text-gray-400"></i>
              </div>
              <h2 className="text-3xl font-bold text-gray-900 mb-4">Start Comparing Vehicles</h2>
              <p className="text-gray-600 mb-8 max-w-md mx-auto">
                Add up to 4 vehicles to compare their features, specifications, and pricing side-by-side
              </p>
              <button
                onClick={() => setShowAddModal(true)}
                className="px-8 py-4 bg-[#2563EB] text-white rounded-full font-medium hover:bg-[#1d4ed8] transition-colors cursor-pointer whitespace-nowrap"
              >
                Add Your First Vehicle
              </button>
            </div>
          ) : (
            <>
              {/* Comparison Table */}
              <div className="overflow-x-auto">
                <div className="inline-block min-w-full">
                  {/* Vehicle Cards Row */}
                  <div className="flex gap-4 mb-8">
                    <div className="w-48 flex-shrink-0">
                      <div className="h-full flex items-end pb-4">
                        <h3 className="text-lg font-bold text-gray-900">Specifications</h3>
                      </div>
                    </div>
                    {selectedVehicles.map(vehicle => (
                      <div key={vehicle.id} className="w-72 flex-shrink-0">
                        <div className="bg-white border-2 border-gray-200 rounded-2xl overflow-hidden">
                          <div className="relative w-full h-48 bg-gray-100">
                            <img
                              src={vehicle.images[0]}
                              alt={vehicle.name}
                              className="w-full h-full object-cover object-top"
                            />
                            <button
                              onClick={() => removeVehicle(vehicle.id)}
                              className="absolute top-3 right-3 w-8 h-8 bg-white/90 hover:bg-white rounded-full flex items-center justify-center cursor-pointer shadow-lg transition-colors"
                            >
                              <i className="ri-close-line text-gray-900"></i>
                            </button>
                            <div className="absolute top-3 left-3 bg-[#2563EB] text-white px-3 py-1 rounded-full text-xs font-medium">
                              {vehicle.badge}
                            </div>
                          </div>
                          <div className="p-6">
                            <h3 className="text-lg font-bold text-gray-900 mb-2">{vehicle.name}</h3>
                            <p className="text-2xl font-bold text-[#2563EB] mb-4">
                              ${vehicle.price.toLocaleString()}
                            </p>
                            <button
                              onClick={() => navigate('/vehicle-details', { state: { vehicle } })}
                              className="w-full py-3 bg-gray-100 text-gray-900 rounded-full font-medium hover:bg-gray-200 transition-colors cursor-pointer whitespace-nowrap text-sm"
                            >
                              View Details
                            </button>
                          </div>
                        </div>
                      </div>
                    ))}
                    {selectedVehicles.length < 4 && (
                      <div className="w-72 flex-shrink-0">
                        <button
                          onClick={() => setShowAddModal(true)}
                          className="w-full h-full min-h-[400px] border-2 border-dashed border-gray-300 rounded-2xl flex flex-col items-center justify-center gap-4 hover:border-[#2563EB] hover:bg-blue-50 transition-all cursor-pointer"
                        >
                          <div className="w-16 h-16 flex items-center justify-center bg-gray-100 rounded-full">
                            <i className="ri-add-line text-3xl text-gray-400"></i>
                          </div>
                          <div className="text-center">
                            <p className="font-semibold text-gray-900 mb-1">Add Vehicle</p>
                            <p className="text-sm text-gray-600">Compare up to 4 vehicles</p>
                          </div>
                        </button>
                      </div>
                    )}
                  </div>

                  {/* Comparison Rows */}
                  <div className="space-y-2">
                    {comparisonRows.map((row, index) => (
                      <div
                        key={index}
                        className={`flex gap-4 ${index % 2 === 0 ? 'bg-gray-50' : 'bg-white'} rounded-xl p-4`}
                      >
                        <div className="w-48 flex-shrink-0 flex items-center">
                          <span className="font-semibold text-gray-700">{row.label}</span>
                        </div>
                        {selectedVehicles.map(vehicle => (
                          <div key={vehicle.id} className="w-72 flex-shrink-0 flex items-center">
                            <span className="text-gray-900">{row.format(vehicle)}</span>
                          </div>
                        ))}
                      </div>
                    ))}

                    {/* Features Comparison */}
                    <div className="flex gap-4 bg-white rounded-xl p-4">
                      <div className="w-48 flex-shrink-0">
                        <span className="font-semibold text-gray-700">Key Features</span>
                      </div>
                      {selectedVehicles.map(vehicle => (
                        <div key={vehicle.id} className="w-72 flex-shrink-0">
                          <div className="space-y-2">
                            {vehicle.features?.slice(0, 5).map((feature, idx) => (
                              <div key={idx} className="flex items-center gap-2">
                                <div className="w-4 h-4 flex items-center justify-center bg-green-100 rounded-full flex-shrink-0">
                                  <i className="ri-check-line text-green-600 text-xs"></i>
                                </div>
                                <span className="text-sm text-gray-700">{feature}</span>
                              </div>
                            ))}
                            {vehicle.features && vehicle.features.length > 5 && (
                              <p className="text-sm text-gray-500 mt-2">
                                +{vehicle.features.length - 5} more features
                              </p>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>

              {/* Action Buttons */}
              <div className="mt-12 flex items-center justify-center gap-4">
                <button
                  onClick={() => setSelectedVehicles([])}
                  className="px-8 py-4 bg-white border-2 border-gray-300 text-gray-900 rounded-full font-medium hover:border-gray-400 transition-colors cursor-pointer whitespace-nowrap"
                >
                  Clear All
                </button>
                <button
                  onClick={() => window.print()}
                  className="px-8 py-4 bg-[#2563EB] text-white rounded-full font-medium hover:bg-[#1d4ed8] transition-colors cursor-pointer whitespace-nowrap flex items-center gap-2"
                >
                  <i className="ri-printer-line"></i>
                  Print Comparison
                </button>
              </div>
            </>
          )}
        </div>
      </section>

      <Footer />

      {/* Add Vehicle Modal */}
      {showAddModal && (
        <div
          className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4"
          onClick={() => {
            setShowAddModal(false);
            setSearchQuery('');
          }}
        >
          <div
            className="bg-white rounded-3xl max-w-4xl w-full max-h-[80vh] overflow-hidden"
            onClick={e => e.stopPropagation()}
          >
            {/* Modal Header */}
            <div className="p-6 border-b border-gray-200">
              <div className="flex items-center justify-between mb-4">
                <h2 className="text-2xl font-bold text-gray-900">Add Vehicle to Compare</h2>
                <button
                  onClick={() => {
                    setShowAddModal(false);
                    setSearchQuery('');
                  }}
                  className="w-10 h-10 flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors cursor-pointer"
                >
                  <i className="ri-close-line text-2xl text-gray-600"></i>
                </button>
              </div>
              <div className="relative">
                <input
                  type="text"
                  value={searchQuery}
                  onChange={e => setSearchQuery(e.target.value)}
                  placeholder="Search by make, model, or year..."
                  className="w-full px-5 py-3 pl-12 border border-gray-300 rounded-full text-sm focus:outline-none focus:ring-2 focus:ring-[#2563EB] focus:border-transparent"
                />
                <i className="ri-search-line absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 text-lg"></i>
              </div>
            </div>

            {/* Modal Content */}
            <div className="p-6 overflow-y-auto max-h-[calc(80vh-180px)]">
              {filteredVehicles.length === 0 ? (
                <div className="text-center py-12">
                  <i className="ri-search-line text-5xl text-gray-300 mb-4"></i>
                  <p className="text-gray-600">No vehicles found matching your search</p>
                </div>
              ) : (
                <div className="grid grid-cols-2 gap-4">
                  {filteredVehicles.map(vehicle => (
                    <div
                      key={vehicle.id}
                      className="bg-white border-2 border-gray-200 rounded-2xl overflow-hidden hover:border-[#2563EB] transition-all cursor-pointer"
                      onClick={() => addVehicle(vehicle)}
                    >
                      <div className="relative w-full h-40 bg-gray-100">
                        <img
                          src={vehicle.images[0]}
                          alt={vehicle.name}
                          className="w-full h-full object-cover object-top"
                        />
                        <div className="absolute top-3 left-3 bg-[#2563EB] text-white px-3 py-1 rounded-full text-xs font-medium">
                          {vehicle.badge}
                        </div>
                      </div>
                      <div className="p-4">
                        <h3 className="font-bold text-gray-900 mb-1">{vehicle.name}</h3>
                        <p className="text-sm text-gray-600 mb-2">{vehicle.mileage} miles</p>
                        <p className="text-xl font-bold text-[#2563EB]">
                          ${vehicle.price.toLocaleString()}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
